import {
  EducationalResource,
  EducationalResourceCreateRequestPayload,
  EducationalResourceUpdateRequestPayload,
  SearchEducationalResourcePayload,
  SearchEducationalResourceResponse,
} from "@/domain/educational-resource.interface";
import { axios, transformAxiosError } from "../utils/axios.create";

const search = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  categoryId,
  type,
  status,
}: SearchEducationalResourcePayload): Promise<SearchEducationalResourceResponse> => {
  const queryParams = new URLSearchParams({
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
    search,
  });

  if (categoryId) {
    queryParams.append("categoryId", categoryId);
  }

  if (type && type.length > 0) {
    type.forEach((t) => queryParams.append("type", t));
  }

  if (status && status.length > 0) {
    status.forEach((s) => queryParams.append("status", s));
  }

  return axios
    .get(`/educational-resources?${queryParams.toString()}`)
    .then((res) => {
      const body = res.data.body;
      return {
        educationalResources: body.educationalResources,
        totalCount: body.totalCount,
      };
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const getById = async (id: string): Promise<EducationalResource> => {
  return axios
    .get(`/educational-resources/${id}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const create = async (data: EducationalResourceCreateRequestPayload) => {
  return axios
    .post("/educational-resources", data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const update = async ({
  id,
  data,
}: {
  id: string;
  data: EducationalResourceUpdateRequestPayload;
}) => {
  const accountId = process.env.REACT_APP_ACCOUNT_ID;
  return axios
    .put(`/educational-resources/${id}`, data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const softDelete = async (id: string) => {
  return axios
    .delete(`/educational-resources/${id}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export const EducationalResourcesService = {
  search,
  getById,
  create,
  update,
  softDelete,
};
